import { ButtonRoundedSm } from '@apps-common/components/elements'
import { ModalBody, ModalCloseButton, ModalContainer, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { ModalDismiss } from '@apps-common/config/modal'
import { OrderUnitType } from '@apps-common/config/orders'

export const SelectUnitStatusModal = ({ onDismiss }: { onDismiss: (data?: string | null | undefined | number, role?: string) => void }) => (
  <ModalContainer innerClasses='!h-auto !min-h-0 !min-w-[300px] sm:!w-auto'>
    <ModalHeaderContainer>
      <div className='flex items-center justify-between'>
        <ModalHeader subtitle='Selection' title='Order Device Type' subtitleClasses='capitalize' />
        <div className='flex items-center gap-[10px]'>
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
        </div>
      </div>
    </ModalHeaderContainer>
    <ModalBody classes='relative !pt-[100px] !pb-[30px] sm:!pb-[20px]'>
      <div className='flex flex-col gap-[16px] pb-[10px] min-w-[200px]'>
        <ButtonRoundedSm
          type='button'
          loading={false}
          text='Inactive'
          className='sm:grow-0 action-info'
          callback={() => onDismiss(OrderUnitType.Inactive, ModalDismiss.Confirm)}
        />
        <ButtonRoundedSm
          type='button'
          loading={false}
          text='Active'
          className='sm:grow-0 action-brand-solid'
          callback={() => onDismiss(OrderUnitType.Active, ModalDismiss.Confirm)}
        />
        {/* TODO: implement the ability to create a new device and add it to the order */}
        {/* <ButtonRoundedSm
          type='button'
          loading={false}
          text='Create'
          className='sm:grow-0 action-success'
          callback={() => onDismiss(OrderUnitType.Create, ModalDismiss.Confirm)}
        /> */}
      </div>
    </ModalBody>
  </ModalContainer>
)
